module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.c002a58f.woff";